import React from "react";
import { useDispatch } from "react-redux";
import { FormBuilder } from "../form/FormBuilder";
import { InsuranceCompany } from "../../interfaces/screens/billing";
import {
  addInsurer,
  updateInsurer,
} from "../../screens/content/settings/insurers/actions";
import { AppDispatch, store } from "../../redux/store";
import { hideModal } from "../../connected-components/modal/reducer";
import { FormComponent } from "../../shared/utils/enums";

interface InsurerEditorProps {
  insurer?: InsuranceCompany;
  isEdit: boolean;
}

const InsurerEditor: React.FC<InsurerEditorProps> = ({ insurer, isEdit }) => {
  const dispatch: AppDispatch = useDispatch();

  const handleFormSubmit = (data: any) => {
    if (isEdit && insurer) {
      dispatch(updateInsurer({ ...insurer, ...data }));
    } else {
      dispatch(addInsurer(data as Omit<InsuranceCompany, "id">));
    }
    store.dispatch(hideModal());
  };

  const schema = {
    type: "object",
    properties: {
      name: {
        type: "string",
        label: "Company Name",
        component: FormComponent.Input,
        required: true,
        componentProps: {},
      },
      insurer_type: {
        type: "string",
        label: "Insurance Type",
        component: FormComponent.Select,
        required: true,
        componentProps: {
          options: [
            { label: "NSSF", value: "nssf" },
            { label: "MOPH", value: "moph" },
            { label: "Private", value: "private" },
            { label: "Cooperative", value: "cooperative" },
            { label: "Corporate", value: "corporate" },
          ],
        },
      },
      contact_person: {
        type: "string",
        label: "Contact Person",
        component: FormComponent.Input,
        required: true,
        componentProps: {},
      },
      phone_number: {
        type: "string",
        label: "Phone Number",
        component: FormComponent.Input,
        required: true,
        componentProps: {},
      },
      email: {
        type: "string",
        label: "Email",
        component: FormComponent.Input,
        required: true,
        componentProps: {},
      },
      address: {
        type: "string",
        label: "Address",
        component: FormComponent.Input,
        required: true,
        componentProps: {},
      },
      // Lebanon-specific fields
      nssf_branch_code: {
        type: "string",
        label: "NSSF Branch Code",
        component: FormComponent.Input,
        required: false,
        componentProps: {},
      },
      moph_contract_number: {
        type: "string",
        label: "MOPH Contract Number",
        component: FormComponent.Input,
        required: false,
        componentProps: {},
      },
      claim_submission_address: {
        type: "string",
        label: "Claim Submission Address",
        component: FormComponent.Input,
        required: false,
        componentProps: {},
      },
      claim_submission_phone: {
        type: "string",
        label: "Claim Submission Phone",
        component: FormComponent.Input,
        required: false,
        componentProps: {},
      },
      claim_submission_email: {
        type: "string",
        label: "Claim Submission Email",
        component: FormComponent.Input,
        required: false,
        componentProps: {},
      },
      processing_time_days: {
        type: "number",
        label: "Processing Time (Days)",
        component: FormComponent.Input,
        required: false,
        componentProps: {
          type: "number",
          min: 1,
        },
      },
      requires_paper_submission: {
        type: "boolean",
        label: "Requires Paper Submission",
        component: FormComponent.Checkbox,
        required: false,
        componentProps: {},
      },
      accepts_electronic_submission: {
        type: "boolean",
        label: "Accepts Electronic Submission",
        component: FormComponent.Checkbox,
        required: false,
        componentProps: {},
      },
      fee_schedule_url: {
        type: "string",
        label: "Fee Schedule URL",
        component: FormComponent.Input,
        required: false,
        componentProps: {},
      },
      notes: {
        type: "string",
        label: "Notes",
        component: FormComponent.Textarea,
        required: false,
        componentProps: {
          rows: 4,
        },
      },
    },
  };

  return (
    <div className="p-4">
      <FormBuilder
        schema={schema}
        onSubmit={handleFormSubmit}
        initialValues={insurer}
      />
    </div>
  );
};

export default InsurerEditor;
